import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BookmarkIcon, FilterIcon, GlobeIcon, ChevronRightIcon, DownloadIcon, TagIcon, ExternalLinkIcon, ListIcon } from 'lucide-react';
// Mock data for tenders
const tenders = [{
  id: 1,
  title: "Construction d'un centre hospitalier à Dakar",
  country: 'Sénégal',
  sector: 'Santé',
  date: '2023-10-15',
  deadline: '2023-11-20',
  budget: '2.5M €',
  status: 'Ouvert',
  new: true
}, {
  id: 2,
  title: "Fourniture d'équipements informatiques pour écoles",
  country: 'Maroc',
  sector: 'Éducation',
  date: '2023-10-12',
  deadline: '2023-11-15',
  budget: '850K €',
  status: 'Ouvert',
  new: true
}, {
  id: 3,
  title: "Développement d'un système d'irrigation agricole",
  country: "Côte d'Ivoire",
  sector: 'Agriculture',
  date: '2023-10-10',
  deadline: '2023-11-10',
  budget: '1.2M €',
  status: 'Ouvert',
  new: false
}, {
  id: 4,
  title: 'Installation de panneaux solaires pour zones rurales',
  country: 'Kenya',
  sector: 'Énergie',
  date: '2023-10-08',
  deadline: '2023-11-05',
  budget: '3.1M €',
  status: 'Ouvert',
  new: false
}, {
  id: 5,
  title: 'Construction de routes et infrastructures urbaines',
  country: 'Tunisie',
  sector: 'Infrastructure',
  date: '2023-10-05',
  deadline: '2023-10-30',
  budget: '4.7M €',
  status: 'Urgent',
  new: false
}];
export function TendersList() {
  const [activeTab, setActiveTab] = useState('recent');
  return <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-313">
      <div className="px-6 py-4 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center justify-between" data-id="element-314">
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-315">
          Appels d'offres récents
        </h2>
        <div className="mt-2 sm:mt-0 flex items-center space-x-2" data-id="element-316">
          <button className="flex items-center text-sm text-gray-600 hover:text-blue-600 px-3 py-1 rounded-md hover:bg-blue-50" data-id="element-317">
            <FilterIcon size={16} className="mr-1" data-id="element-318" />
            Filtrer
          </button>
          <button className="flex items-center text-sm text-gray-600 hover:text-blue-600 px-3 py-1 rounded-md hover:bg-blue-50" data-id="element-319">
            <GlobeIcon size={16} className="mr-1" data-id="element-320" />
            Tous les pays
          </button>
        </div>
      </div>
      <div className="border-b border-gray-200" data-id="element-321">
        <nav className="flex -mb-px" data-id="element-322">
          <button onClick={() => setActiveTab('recent')} className={`py-3 px-4 text-sm font-medium border-b-2 ${activeTab === 'recent' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-323">
            Récents
          </button>
          <button onClick={() => setActiveTab('saved')} className={`py-3 px-4 text-sm font-medium border-b-2 ${activeTab === 'saved' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-324">
            Favoris
          </button>
          <button onClick={() => setActiveTab('matched')} className={`py-3 px-4 text-sm font-medium border-b-2 ${activeTab === 'matched' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-325">
            Recommandés pour vous
          </button>
        </nav>
      </div>
      <div className="overflow-x-auto" data-id="element-326">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-327">
          <thead className="bg-gray-50" data-id="element-328">
            <tr data-id="element-329">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-330">
                Titre
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-331">
                Pays
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-332">
                Secteur
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-333">
                Date limite
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-334">
                Budget
              </th>
              <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-335">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-336">
            {tenders.map(tender => <tr key={tender.id} className="hover:bg-gray-50" data-id="element-337">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-338">
                  <div className="flex items-center" data-id="element-339">
                    <div data-id="element-340">
                      <div className="text-sm font-medium text-gray-900 flex items-center" data-id="element-341">
                        {tender.title}
                        {tender.new && <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-342">
                            Nouveau
                          </span>}
                        {tender.status === 'Urgent' && <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-343">
                            Urgent
                          </span>}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-344">
                        Publié le{' '}
                        {new Date(tender.date).toLocaleDateString('fr-FR')}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-345">
                  <div className="text-sm text-gray-900" data-id="element-346">{tender.country}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-347">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-348">
                    {tender.sector}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-349">
                  {new Date(tender.deadline).toLocaleDateString('fr-FR')}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-350">
                  {tender.budget}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-351">
                  <div className="flex justify-end space-x-2" data-id="element-352">
                    <button className="text-gray-400 hover:text-blue-600" data-id="element-353">
                      <BookmarkIcon size={18} data-id="element-354" />
                    </button>
                    <button className="text-gray-400 hover:text-blue-600" data-id="element-355">
                      <DownloadIcon size={18} data-id="element-356" />
                    </button>
                    <button className="text-blue-600 hover:text-blue-800" data-id="element-357">
                      <ChevronRightIcon size={18} data-id="element-358" />
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between" data-id="element-359">
        <div className="text-sm text-gray-500" data-id="element-360">
          Affichage de 5 appels d'offres sur 1,253
        </div>
        <div className="flex items-center space-x-1" data-id="element-361">
          <div className="flex space-x-1" data-id="element-362">
            <button className="px-3 py-1 rounded-md text-sm text-gray-600 hover:bg-gray-100" data-id="element-363">
              Précédent
            </button>
            <button className="px-3 py-1 rounded-md text-sm text-white bg-blue-600 hover:bg-blue-700" data-id="element-364">
              1
            </button>
            <button className="px-3 py-1 rounded-md text-sm text-gray-600 hover:bg-gray-100" data-id="element-365">
              2
            </button>
            <button className="px-3 py-1 rounded-md text-sm text-gray-600 hover:bg-gray-100" data-id="element-366">
              3
            </button>
            <button className="px-3 py-1 rounded-md text-sm text-gray-600 hover:bg-gray-100" data-id="element-367">
              Suivant
            </button>
          </div>
          <Link to="/premium-tenders" className="ml-4 flex items-center px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 transition-colors" data-id="element-368">
            <ListIcon size={16} className="mr-2" data-id="element-369" />
            Voir tous les appels d'offres
          </Link>
        </div>
      </div>
    </div>;
}